import { bulkUploadInventoryIcon } from "assets/icons/svgIcons";

export default [
  {
    id: "Upload",
    title: "Upload Inventories",
    icon: bulkUploadInventoryIcon,
    pageTitle: "Upload Inventories",
    navLink: "/uploadDocument",
    type: "item",
    isActive: true,
    permissions: ["super_admin", "sheet_upload", "moh_inventory",]
  },
];